import { Pipe } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
var TruncateWordsPipe = (function () {
    function TruncateWordsPipe() {
    }
    TruncateWordsPipe.prototype.transform = function (value, limit, trail) {
        if (limit === void 0) { limit = 40; }
        if (trail === void 0) { trail = '…'; }
        var result = value || '';
        if (value) {
            var words = value.split(/\s+/);
            if (words.length > Math.abs(limit)) {
                if (limit < 0) {
                    limit *= -1;
                    result = trail + words.slice(words.length - limit, words.length).join(' ');
                }
                else {
                    result = words.slice(0, limit).join(' ') + trail;
                }
            }
        }
        return result;
    };
    /** @nocollapse */
    TruncateWordsPipe.ctorParameters = function () { return []; };
TruncateWordsPipe.ɵfac = function TruncateWordsPipe_Factory(t) { return new (t || TruncateWordsPipe)(); };
TruncateWordsPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "words", type: TruncateWordsPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TruncateWordsPipe, [{
        type: Pipe,
        args: [{
                name: 'words'
            }]
    }], function () { return []; }, null); })();
    return TruncateWordsPipe;
}());
export { TruncateWordsPipe };

